import { components } from './openapi/svc-messaging-sse-router-api'

export enum EventTypes {
  RefreshConversation = 'refresh_conversation',
}

export type SSEEventData = Omit<components['schemas']['message'], 'data' | 'message_type'> & {
  data: { user_msg_thread_id: number }
  message_type: EventTypes
}

export type SSEConnectionOptions = {
  url: string | URL
  headers?: Record<string, string>
}
